import paymentMethodTypes from 'common/constants/paymentMethodTypes'
import { PricePlanTypeEnum } from 'common/enums/PricePlanTypeEnum'
import { usePayment } from 'publisher/store'
import paymentSelectors, {
  getActivePricePlan,
  getOfferCurrency,
} from 'publisher/store/payment/paymentSelectors'
import { useMemo } from 'react'

type PaypalUpsellOptions = {
  clientId: string
  currency: string
  vault?: true
  intent?: 'subscription'
}

export const usePaypalUpsellOptions = (): PaypalUpsellOptions | null => {
  const paymentMethod = usePayment(paymentSelectors.getActivePaymentMethod)
  const pricePlan = usePayment(getActivePricePlan)
  const currency = usePayment(getOfferCurrency)
  const isPaypalRest = paymentMethod === paymentMethodTypes.PAYPAL_REST
  const isSubscriptionPricePlan =
    pricePlan && pricePlan.type !== PricePlanTypeEnum.OneShot

  return useMemo(() => {
    if (!isPaypalRest) {
      return null
    }

    const options: PaypalUpsellOptions = {
      clientId: `${process.env.PAYPAL_CLIENT_ID}`,
      currency: currency.toLocaleUpperCase(),
    }

    if (isSubscriptionPricePlan) {
      return {
        ...options,
        vault: true,
        intent: 'subscription',
      }
    }

    return options
  }, [currency, isPaypalRest, isSubscriptionPricePlan])
}
